import api from "../api";
import apiNoAuth from "../apiNoAuth";

export class BillingService {

    static fetchFees(project_type_id) {return api.get(`billing/fees?project_type_id=${project_type_id}`)}
}